// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__19Z51","requiredAsterisk":"Info_requiredAsterisk__3LXre"};